import React, { SVGProps } from 'react';

const GreyClock = ({
  color = 'var(--secondaryText)',
  width = 16,
  height = 16,
  className,
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    viewBox="0 0 16 16"
    className={className}
  >
    <path
      d="M8 14.667A6.667 6.667 0 1 1 8 1.334a6.667 6.667 0 0 1 0 13.333Zm0-1.334A5.333 5.333 0 1 0 8 2.666a5.333 5.333 0 0 0 0 10.667ZM8.667 8h2.666v1.333h-4V4.667h1.334V8Z"
      fill="currentColor"
    />
  </svg>
);

export default GreyClock;
